import Vue from 'vue';
import Vuex from 'vuex';
import editor from './modules/editor';
import user from './modules/user';
import checkout from './modules/checkout';
import app from './modules/app';
import admin from './modules/admin';
import slid from './modules/slid';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    editor,
    user,
    checkout,
    admin,
    slid,
  },
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
